export enum MCPTrasport {
  sse = 'sse',
  streamableHttp = 'streamableHttp',
}
